/**
 * Created by dreamc_t on 2017/3/3.
 */
var init = require('./module/head');

module.exports = init;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.login/app/index.js